export default __webpack_public_path__ + "static/media/nz.ef34811c.png";